<template>
	<el-dialog class="agreeDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				平台用户购买须知协议
			</div>
		</div>
		<div class="dislogConent">
			<div class="mainTitle f_w_700">平台用户购买须知协议</div>
			<div class="subTitle d_f_a_c f_w_700">
				制定方：
				<div class="f_w_400">[岱屿画境] 平台（以下简称"平台"）</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				公司名称：
				<div class="f_w_400">杭州岱屿画境科技有限公司</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				生效日期：
				<div class="f_w_400">[2025年12月31日]</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				规则性质：
				<div class="f_w_400">本规则为《平台创作者注册协议》的有效组成部分</div>
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				重要提示：
			</div>
			<div class="subTitle t-indent f_w_700">
				尊敬的用户，欢迎您使用[岱屿画境]平台服务！在您浏览、选购作品前，请务必仔细阅读并充分理解本《用户购买须知协议》（以下简称“本须知”）全部内容。您通过平台购买任何作品的行为，即视为您已阅读、理解并同意接受本须知及平台其他相关规则的全部内容约束。如您不同意本须知任何内容，请立即停止购买行为。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第一条 购买前提
			</div>
			<div class="subTitle t-indent f_w_400">
				1.您确认，在您进行购买时，您是符合中华人民共和国法律规定的具有完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请在监护人指导下进行，否则您及您的监护人应承担由此导致的一切后果。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.您应确保您的账户状态正常，并已了解平台的支付方式。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第二条 作品授权模式理解与接受
			</div>
			<div class="subTitle t-indent f_w_400">
				您理解并完全接受，您在平台上购买的是数字作品的“使用权许可”或“知识产权转让”，而非实物商品。您获得的全部权利范围，严格取决于您在购买时选择的、由创作者设定的作品售卖模式。平台提供的售卖模式包括但不限于以下四种，您在购买前务必仔细阅读作品详情页的授权说明：
			</div>
			<div class="subTitle t-indent f_w_400">
				1.<span class="f_w_700">个人欣赏使用许可（非独占）</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 授权性质：非独占性使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 适用范围：允许个人或公司以欣赏、个人收藏或非商业性使用（如壁纸、AI语聊头像或背景等）为目的使用作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 权利保留：创作者保留作品完整知识产权，可继续向多个用户授予同类许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 用户限制：用户不得将作品用于任何商业用途或牟利行为。
			</div>
			<div class="subTitle t-indent f_w_400">
				2.<span class="f_w_700">个人独家欣赏使用许可（独占）</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 授权性质：独占性使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 适用范围：允许用户独家以欣赏、个人收藏或非商业性使用为目的使用作品。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 权利限制：创作者不得再次售卖该作品或许可任何第三方使用，用户不得将作品用于任何商业用途。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">有范围的商业许可</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 授权性质：非独占性商业使用许可。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：用户可在创作者明确授权的特定范围（如广告设计、产品包装、限定次数的营销使用等）或特定品类内，在特定时间中使用作品，品类+地域+时间+数量，例“仅限用于中国市场的A品牌产品包装，授权期为一年，产量不超过1万件”。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 权利保留：创作者可继续将作品其他领域或其他品类出售给他人（个人欣赏或有限商业用途）。
			</div>
			<div class="subTitle t-indent f_w_400">
				3.<span class="f_w_700">完全买断许可</span>
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 授权性质：著作权及相关知识产权全部转让。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span>
				适用范围：创作者将作品的所有权、知识产权及其他一切权利永久性、排他性地转让给用户。
			</div>
			<div class="subTitle t-indent f_w_400">
				<span class="point"></span> 权利限制：交易完成后，作品将从平台下架，创作者不得再以任何形式出售、使用或许可该作品。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第三条 购买流程与支付
			</div>
			<div class="subTitle t-indent f_w_400">
				1. 您应按照平台提示的流程选择作品、确认授权模式、完成支付。
			</div>
			<div class="subTitle t-indent f_w_400">
				2. 支付完成后，除法定或平台约定的特殊情况（如作品无法下载、与描述严重不符等）外，<span class="f_w_700">数字商品交易一般不适用无理由退款。</span>请您在支付前慎重确认。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第四条 用户义务与承诺
			</div>
			<div class="subTitle t-indent f_w_400">
				1．<span class="f_w_700">按授权使用：</span>
				您保证将严格按照所购作品的授权模式使用作品，不会进行任何超范围、超期限的使用。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．<span class="f_w_700">禁止侵权行为：</span>
				不得对购买的作品进行复制、分发、修改、公开展示或用于任何未经明确授权的商业活动，除非该行为在您购买的授权范围内明确允许。
			</div>
			<div class="subTitle t-indent f_w_400">
				3．<span class="f_w_700">禁止“跳单”行为：</span>
				您理解并同意，所有交易应在平台内完成。您不得在平台内或通过任何渠道引导、提议创作者进行私下交易，以规避平台规则。此行为严重损害平台及创作者利益，平台有权据此对您的账户采取限制或封禁等措施。
			</div>
			<div class="subTitle t-indent f_w_400">
				4．<span class="f_w_700">内容合法：</span>
				您使用作品的方式及最终成品须符合法律法规，不涉及违法、侵权、违背公序良俗等内容。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第五条 平台免责声明
			</div>
			<div class="subTitle t-indent f_w_400">
				1．<span class="f_w_700">平台角色：</span>
				平台是中立的技术服务提供方与交易组织者，不对创作者上传作品的权利瑕疵、内容合法性、质量及与描述的相符性作任何实质性保证或担保。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．<span class="f_w_700">风险自担：</span>
				因使用作品产生的任何纠纷、损失（包括但不限于因您超授权范围使用导致的第三方索赔），您应直接与创作者协商解决。平台可提供必要的协助，但不承担直接或连带责任。
			</div>
			<div class="subTitle t-indent f_w_400">
				3．<span class="f_w_700">服务保障：</span>
				平台尽力确保服务稳定，但对于因技术、网络、不可抗力等导致的服务中断、数据丢失等问题，平台不承担责任。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第六条 知识产权与侵权处理
			</div>
			<div class="subTitle t-indent f_w_400">
				1．您尊重并认可，作品的一切知识产权在交易前归属于创作者。
			</div>
			<div class="subTitle t-indent f_w_400">
				2．如您认为在平台购买的作品侵犯了您的合法权益，请通过平台指定的渠道提交投诉，平台将依法进行处理。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第七条 【规则修订】
			</div>
			<div class="subTitle t-indent f_w_400">
				平台有权根据业务需要修订本规则，修订后的规则通过平台公告等方式公布后生效。规则修订后，创作者继续使用本平台进行交易的，视为同意本规则的修改。
			</div>
			<div class="subTitle d_f_a_c f_w_700">
				第八条 争议解决
			</div>
			<div class="subTitle t-indent f_w_400">
				因本规则引起的争议，双方应友好协商解决；协商不成的，任何一方均有权向上海市普陀区人民法院提起诉讼。败诉方应承担胜诉方全部的维权费用包括诉讼费用、聘请律师费用、公证费用等。
			</div>
			<div class="subTitle t-indent f_w_400">
				再次提醒您：购买数字作品即购买一份权利许可，请务必在支付前确认您理解并接受该许可的全部条款！
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.agreeDialog {

		::v-deep .el-dialog {
			width: 12rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem 0;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				height: 5rem;
				overflow-y: auto;
				padding: 0 .24rem .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
			}
		}
	}

	.mainTitle {
		margin-top: .12rem;
		text-align: center;
	}

	.subTitle {
		margin-top: .12rem;
	}

	.t-indent {
		text-indent: 2em;
	}

	.d_f_a_c {
		display: flex;
		align-items: center;
	}

	.f_w_700 {
		font-weight: 700;
	}

	.f_w_400 {
		font-weight: 400;
	}

	.point {

		&::before {
			display: inline-block;
			margin-right: .04rem;
			content: '';
			width: .08rem;
			height: .08rem;
			background: #252525;
			border-radius: 50%;
		}
	}

	.square {

		&::before {
			display: inline-block;
			margin-right: .04rem;
			content: '';
			width: .08rem;
			height: .08rem;
			background: #252525;
			border-radius: .02rem;
		}
	}
</style>